import getDataLayer from './getDataLayer';
import { getOwnCategory } from '../getOwnCategory';
import { IOrderFull, IPurchase } from '../../typings/IOrderItem';
import { DL_CURRENCY, DlEcommerceEvents } from './constant';

export const DL_Purchase = (order: IOrderFull) => {
  getDataLayer().push({
    event: DlEcommerceEvents.PURCHASE,
    ecommerce: {
      transaction_id: order.id,
      currency: DL_CURRENCY,
      value: order.productsPrice,
      shipping: order.deliveryCost,
      coupon: order.coupon?.code || null,
      items: [
        ...order.purchases.map((purchase: IPurchase) => {
          const product = purchase.product;
          const customCategory = getOwnCategory(product?.customCategories);
          return {
            item_name: product?.titleDe || product?.title,
            item_id: product?.id,
            item_category: customCategory?.name,
            item_brand: product?.brand?.nameDe,
            item_list_id: purchase.trackingItemListId,
            item_list_name: purchase.trackingItemListName,
            price: purchase.productPrice,
            quantity: purchase.count,
          };
        }),
      ],
    },
  });
};
